import Vue from 'vue';
import BaseLocator from '@app/modules/RF/Locator/BaseLocator.vue';
export default Vue.extend({
    extends: BaseLocator,
    props: {
        input: Object
    }
});
